import React, { useRef } from 'react'

import { Button, Line, Span } from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import Draggable from 'react-draggable'
import { FONTS } from 'utils'

import { IGetContratoId } from './../../../../../../types/index'
import {
  DialogContentStyled,
  DialogTitleStyled,
  DialogActionsStyled,
  ContainerLista,
  ItemLista
} from './ModalContratos.styles'

interface IModalContratos {
  showModal: boolean
  toggleModal: () => void
  listaContratos: IGetContratoId[] | []
  selectContract: (_id: any, cdContrato: string) => void
}
const ModalContratos: React.FC<IModalContratos> = ({
  showModal,
  toggleModal,
  listaContratos,
  selectContract
}) => {
  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      reference={draggableReference}
      showModal={showModal}
      onClose={toggleModal}
      width={'sm'}
    >
      <Line />
      <DialogTitleStyled>Contratos Encontrados</DialogTitleStyled>
      <DialogContentStyled>
        <ContainerLista>
          {listaContratos.length > 0 ? (
            listaContratos?.map((el: IGetContratoId) => (
              <ItemLista
                key={el.idContrato.toString()}
                onClick={() => selectContract(el.idContrato, el.cdContrato)}
              >
                {el.cdContrato}
              </ItemLista>
            ))
          ) : (
            <Span
              text="Não encontramos contratos com este código!"
              fontWeight={FONTS.bold}
              color="red"
            />
          )}
        </ContainerLista>
      </DialogContentStyled>
      <DialogActionsStyled>
        <Button
          text="Fechar"
          onClick={() => {
            toggleModal()
            resetModalState(draggableReference)
          }}
        />
      </DialogActionsStyled>
    </DraggableDialog>
  )
}

export default ModalContratos
